import { Body2, Tiny1, Title4 } from 'components/Typography';
import Image from 'next/image';
import React from 'react';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { headerStatus } from 'interfaces/header-status.enum';
import { getStaticAssetUrl } from 'utils/url';

interface EcosystemData {
  title: string;
  description: string;
  Link: string;
  logo: string;
  backDetails: string;
  status?: string;
}

interface EcoSystemCardDesktopProps {
  cardData: EcosystemData[];
}

export const EcoSystemCardDesktop: React.FC<EcoSystemCardDesktopProps> = ({
  cardData,
}) => {
  const { t } = useTranslation('ecosystem');
  return (
    <>
      {cardData.map((item, index) => (
        <div className='perspective-[800px] h-full' key={index}>
          <div className='group relative h-full w-full transition-transform duration-1000 transform-style-preserve-3d hover:rotate-y-180'>
            <div className='relative inset-0 flex h-full items-center justify-center border-[0.5px] border-black-300 p-5 backface-hidden'>
              <div className='flex h-full w-full flex-col justify-between'>
                <div
                  className='mb-3 flex items-start gap-3 border-b border-dashed border-black-300 pb-4'
                  style={{
                    borderImage:
                      'repeating-linear-gradient(45deg, #b5b5b5 0px, #b5b5b5 10px, transparent 10px, transparent 20px) 1',
                  }}
                >
                  <Image
                    alt={item.title}
                    src={item.logo}
                    className='h-16 w-16 rounded-full bg-black-900 p-2'
                    height={80}
                    width={80}
                  />
                  <Title4 className='py-3 text-white'>{item.title}</Title4>
                </div>
                <Body2 className='mb-5 font-normal text-mono-100'>
                  {item.description}
                </Body2>
                <div className='mt-2 flex items-center justify-between'>
                  <Image
                    src={getStaticAssetUrl('/sfi/static/svgs/explore.svg')}
                    width='20'
                    height='20'
                    alt=''
                  />
                  {item.status === 'COMING_SOON' ? (
                    <Tiny1 className='text-positive-800'>
                      {t('common:LINK_STATUS.' + headerStatus.COMING_SOON)}
                    </Tiny1>
                  ) : (
                    <Button
                      className='px-4 py-2 text-sm font-normal'
                      onClick={() => {
                        window.open(item.Link, '_blank');
                      }}
                    >
                      {t('VIEW')}
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <div className='absolute inset-0 flex rotate-y-180 items-center justify-center bg-white p-5 backface-hidden'>
              <div className='flex h-full w-full flex-col justify-between'>
                <Body2 className='no-scrollbar h-full overflow-y-auto font-normal tracking-[0.4px] text-black-1000'>
                  <span style={{ wordSpacing: '10px' }}>
                    {item.backDetails}
                  </span>
                </Body2>
                <div className='flex items-center justify-between'>
                  <Image
                    src={getStaticAssetUrl('/sfi/static/svgs/explore_dark.svg')}
                    width='20'
                    height='20'
                    alt=''
                  />
                  {item.status === headerStatus.COMING_SOON ? (
                    <Tiny1 className='text-positive-800'>
                      {t('common:LINK_STATUS.' + headerStatus.COMING_SOON)}
                    </Tiny1>
                  ) : (
                    <Link
                      href={item.Link}
                      target='_blank'
                      className='rounded-full bg-gradient-to-r from-[#151518] to-[#0E0E13] px-4 py-2'
                    >
                      <Body2 className='font-normal tracking-[0.4px] text-white'>
                        {t('VIEW')}
                      </Body2>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
